// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "@firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBDvBck5Xz3evo-NOxFbZhUy_hIk0XOPCc",
  authDomain: "gaias-prod.firebaseapp.com",
  projectId: "gaias-prod",
  storageBucket: "gaias-prod.appspot.com",
  messagingSenderId: "647493454641",
  appId: "1:647493454641:web:07ad00b506a2d2e9b77e10",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(app);
export const db = getFirestore(app);
export const supplierFileBucket = getStorage(
  app,
  process.env.REACT_APP_SUPPLIER_FILE_UPLOAD_BUCKET,
);
